// 语音合成相关api
import request from '@/utils/request'

//语音合成列表
export function getvoiceList(data) {
    return request({
        url: '/general/voiceSynthesis/getList',
        method: 'post',
        data: data
    })
}

// 添加语音合成
export function addVoiceSynthesis(query) {
    return request({
        url: '/general/voiceSynthesis/addVoiceSynthesis',
       method: 'post',
        data: query
    })
}

// 删除语音合成
export function delVoiceSynthesis(query) {
    return request({
        url: '/general/voiceSynthesis/delVoiceSynthesis',
        method: 'post',
        data: query
    })
}

// 识别文字
export function speechSynthesis(query) {
    return request({
        url: '/general/xunfei/speechSynthesis',
        method: 'post',
        data: query
    })
}
export function stream(query) {
    return request({
        url: '/general/api/chat/stream',
        method: 'post',
        data: query
    })
}
export function BaseUploadImg(query) {
    return request({
        url: '/general/imgProcessing/BaseUploadImg',
        method: 'post',
        data: query
    })
}
